import React, { useContext } from "react";
import { Link } from "react-router-dom";
import product1 from '../images/category-baby-care.jpg'
import product2 from '../images/category-atta-rice-dal.jpg'
import product3 from '../images/category-bakery-biscuits.jpg'
import product4 from '../images/category-chicken-meat-fish.jpg'
import product5 from '../images/category-cleaning-essentials.jpg'
import product6 from '../images/category-dairy-bread-eggs.jpg'
import product7 from '../images/category-instant-food.jpg'
import product8 from '../images/category-pet-care.jpg'
import product9 from '../images/category-snack-munchies.jpg'
import product10 from '../images/category-tea-coffee-drinks.jpg'
import Swal from 'sweetalert2';
import { CartContext, ProductsContext, UserContext, WishlistContext } from "../App";
import ProductCard from "../Component/ProductCard";
import api from "../api";

const ProductItem = () => {
   const { user } = useContext(UserContext);
   const {products, setProducts} = useContext(ProductsContext)
   const { cart,cartDispatch } = useContext(CartContext);
   const { wishlist,wishlistDispatch } = useContext(WishlistContext);

    const addToCart = async (product, quantity=1) => {
      if (user) {
           const resp = await api.addProductsToCart([{product:product, quantity}])
           
           if (resp) {
             cartDispatch({type: "ADD_PRODUCTS", payload: [{...product, quantity}]})
           }
         } else {
           cartDispatch({type: "ADD_PRODUCTS", payload: [{...product, quantity}]})
         }
      }
     
    const addToWishlist = async (product, quantity=1) => {
      if (user) {
           const resp = await api.addProductsToWishlist([{product:product}])
           wishlistDispatch({type: "ADD_PRODUCTS_LIST", payload: [{...product, quantity}]})
           // if (resp) {
           //   cartDispatch({type: "ADD_PRODUCTS", payload: [{...product, quantity}]})
           // }
        } else {
           wishlistDispatch({type: "ADD_PRODUCTS_LIST", payload: [{...product, quantity}]})
         }
      }
     
    const removeProductWishlist = async (id, quantity) => {
        console.log("removing id",id)
        wishlistDispatch({type: "REMOVE_PRODUCT_LIST", payload: id})
        api.removeProductFromWishlist(id);
        return;
        // cartDispatch({type: "SET_PRODUCT_QUANTITY", payload: {id, quantity}})
        //  api.patchCart(id, quantity)
    }

  const handleAddClick = () => {
    Swal.fire({
      icon: 'success',
      title: 'Added to Cart',
      text: "Product has been added to your cart!",
      showConfirmButton: true,
      timer: 3000,
    });
  };
  return (
    <div>
      {/* Popular Products Start*/}
      <section className="my-lg-14 my-8">
        <div className="container">
          <div className="row">
            <div className="col-12 mb-6">
            <div className="section-head text-center mt-8" >
              <h3 className='h3style' data-title="">Popular Products</h3>
              <div className="wt-separator bg-primarys">
              </div>
              <div className="wt-separator2 bg-primarys">
              </div>
              {/* <p>Connecting with entrepreneurs online, is just a few clicks away.</p> */}
            </div>
            </div>
          </div>
          <div className="row g-4 row-cols-lg-5 row-cols-2 row-cols-md-3">
             {[...products].slice(0,5).map((product)=>(
                  <ProductCard
                    key={product?._id}
                    itemId={product.itemId}
                    image={product?.imgPath?.split(";")[0]}
                    category={product?.cat_name}
                    title={product?.iName}
                    rating="4.5"
                    reviews="149"
                    price={product?.rate}
                    oldPrice={product?.tranRate}
                    best={"false"}
                    onAddToCart={()=> addToCart(product)}
                    addedToCart={cart?.products?.some(item => item.itemId == product?.itemId)}
                    onAddToWishlist={()=>addToWishlist(product)}
                    onRemoveFromWishlist={()=> removeProductWishlist(product?._id)}
                    isWishlisted={wishlist?.products?.some(item => item.itemId == product?.itemId)}
                  />
                ))}
          </div>
        </div>
      </section>
      {/* Popular Products End*/}
    </div>
  );
};

export default ProductItem;
